import {
  PathnameAccounting,
  PathnameGenerator,
} from "./pathnames/pathname.accounting";

import {
  PathnameInventory,
  PathnameGenerator as PathnameGeneratorInventory,
} from "./pathnames/pathname.inventory";

import {
  PathnameManufacturing,
  PathnameGenerator as PathnameGeneratorManufacuring,
} from "./pathnames/pathname.manufacturing";

import {
  PathnameCrm,
  PathnameGenerator as PathnameGeneratorCrm,
} from "./pathnames/pathname.crm";

import {
  PathnamePurchase,
  PathnameGenerator as PathnameGeneratorPurchase,
} from "./pathnames/pathname.procurement";
import {
  PathnameUsers,
  PathnameGenerator as PathnameGeneratorUsers,
} from "./pathnames/pathname.user";

import {
  PathnameRental,
  PathnameGenerator as PathnameGeneratorRental,
} from "./pathnames/pathname.rental";

import { PathnameGenerator as PathnameGeneratorHrms, PathnameHrms } from "./pathnames/pathname.hrms";

import {
  assetTransferColumns,
  attributesColumns,
  bankAccountColumns,
  bankColumns,
  billOfMaterialColumns,
  gateRegisterColumns,
  binsColumns,
  binTransferColumns,
  budgetColumns,
  buildOrderColumns,
  cashExpensesColumns,
  chartOfAccountsColumns,
  collectionColumns,
  commissionAssignmentColumns,
  commissionAuthorizationColumns,
  commissionColumns,
  commissionPlanColumns,
  getCommissionTargetColumns,
  monthWiseCommissionColumns,
  creditNoteColumns,
  currencyColumns,
  currencyExchangeColumns,
  journalTypeColumns,
  customerManagementColumns,
  customerReturnsColumns,
  customerSegmentColumns,
  debitNoteColumns,
  deliveryOrderColumns,
  discountedItemsColumns,
  equipmentColumns,
  equipmentFailureColumns,
  expenseReimbursementColumns,
  expenseReportsColumns,
  fiscalYearColumns,
  inventoryAdjustmentColumns,
  inventoryItemColumns,
  itemCategoryColumns,
  jobCardsColumns,
  masterJobCardColumns,
  journalEntryColumns,
  leadColumns,
  locationColumns,
  operationBlocksColumns,
  operationsColumns,
  opportunityColumns,
  paymentColumns,
  paymentRequestColumns,
  paymentTermsColumns,
  promotionColumns,
  purchaseAgreementColumns,
  purchaseDeliveryOrderColumns,
  purchaseInvoiceColumns,
  quotationColumns,
  purchaseLandedCostColumns,
  purchaseOrderColumns,
  purchaseRequestColumns,
  purchaseRfqColumns,
  purchaseVraColumns,
  approvedVsPendingPoReportColumns,
  materialRequirementExceptionReportColumns,
  supplierContractComplianceReportColumns,
  supplierRankingScorecardReportColumns,
  purchaseReturnReportColumns,
  purchaseOrderCancellationReportColumns,
  purchaseOrderSummaryReportColumns,
  purchaseOrderDetailReportColumns,
  purchaseTrendReportColumns,
  receivedVsOrderedReportColumns,
  supplierAgingPayableReportColumns,
  purchasePriceVarianceReportColumns,
  openPurchaseOrderReportColumns,
  purchaseInvoiceSummaryReportColumns,
  purchaseInvoiceDetailReportColumns,
  routeRulesColumns,
  routingColumns,
  salesInvoiceColumns,
  salesOrderColumns,
  salesByProductReportColumns,
  salesOrderSummaryReportColumns,
  salesInvoiceSummaryReportColumns,
  salesInvoiceDetailReportColumns,
  salesCommissionIncentiveReportColumns,
  salesChannelAnalysisReportColumns,
  salesDiscountPromotionAnalysisReportColumns,
  salesBySalespersonPerformanceReportColumns,
  pendingQuotesApprovalsReportColumns,
  orderFulfillmentDeliveryReportColumns,
  customerChurnRetentionReportColumns,
  salesReturnCreditNoteReportColumns,
  regionalBranchSalesPerformanceReportColumns,
  salesOrderDetailReportColumns,
  scrapColumns,
  shippingRuleColumns,
  stockTransferColumns,
  taxCategoryColumns,
  taxCodeColumns,
  taxTemplateColumns,
  unBuildOrderColumns,
  uomColumns,
  vendorManagementColumns,
  workCenterCategoriesColumns,
  workCenterColumns,
  workOrderColumns,
  workOrderOperationsColumns,
  rentalTermsAndConditionsColumns,
  crmTermsAndConditionsColumns,
  purchaseTermsAndConditionsColumns,
  rentalConfigurationColumns,
  rentalBillingCycleColumns,
  userColumns,
  assetManagementColumns,
  rentalOpportunityColumns,
  rentalLeadColumns,
  rentalQuotationColumns,
  rentalAgreementsColumns,
  rentalCrossHireRequestColumns,
  rentalCrossHireRfqColumns,
  rentalOrderColumns,
  rentalCrossHireOrderColumns,
  languageColumns,
  emailColumns,
  rolesColumns,
  // Inventory Report Columns
  inventoryAgingReportColumns,
  inventoryCostAnalysisReportColumns,
  returnToVendorReportColumns,
  slowMovingInventoryReportColumns,
  stockMovementTurnoverReportColumns,
  stockOnHandReportColumns,
  stockReconciliationReportColumns,
  stockReservationReportColumns,
  warehouseStockAgingReportColumns,
  warehouseTransfersReportColumns,
  hrmsDocumentMasterColumns,
  hrmsCompanyCalendarColumns,
  hrmsLeavePolicyMasterColumns,
  hrmsSalaryStructureMasterColumns,
  hrmsEmployeeManagementColumns,
  hrmsLoanConfigurationColumns,
  rentalRevenueReportColumns,
  rentalAgreementReportColumns,
  rentalAgreementDetailReportColumns,
  rentalAssetReturnReportColumns,
  rentalCancellationsAmendmentsReportColumns,
  rentalPaymentAgingReportColumns,
  activeRentalsReportColumns,
  upcomingExpiryReportColumns,
  assetAvailabilityReportColumns,
  assetUtilizationReportColumns,
  assetCategoryPerformanceReportColumns,
  customerRentalReportColumns,
  journalItemReportColumns,
} from "./defaultColumns";
import { Pathname } from "./pathnames/pathname";
import { TEMPLATE_EDITOR_PATHS } from "../views/template-editor/utils/constant";

export interface IResources {
  pageResource: string;
  fieldResource: string;
  formResource: string;
  permissionKey?: string;
  pageResourceName?: string;
}
export interface IColumns {
  defaultColumns: any[];
}

export const routeToResourceMap: Record<string, IResources> = {

  // User Module
  [PathnameGeneratorUsers(PathnameUsers.USER)]: {
    pageResource: "user",
    fieldResource: "user",
    formResource: "user",
    permissionKey: "User",
  },
  [PathnameGeneratorUsers(PathnameUsers.ROLE)]: {
    pageResource: "role",
    fieldResource: "roles",
    formResource: "roles",
    permissionKey: "Role",
  },
  //Accounting Module
  [PathnameGenerator(PathnameAccounting.JOURNAL_ENTRY)]: {
    pageResource: "journal_entries",
    fieldResource: "journal_entries",
    formResource: "journal_entries",
    permissionKey: "JournalEntries",
    pageResourceName: "journal_entries",
  },
  [PathnameGenerator(PathnameAccounting.PAYMENT)]: {
    pageResource: "payment_entries",
    fieldResource: "payment_entries",
    formResource: "payment_entries",
    permissionKey: "PaymentEntries.entries",
    pageResourceName: "payment_entries",
  },
  [PathnameGenerator(PathnameAccounting.COLLECTION)]: {
    pageResource: "collection_entries",
    fieldResource: "collection_entries",
    formResource: "collection_entries",
    permissionKey: "PaymentEntries.entries",
    pageResourceName: "collection_entries",
  },
  // [PathnameGenerator(PathnameAccounting.PAYMENT_REQUEST)]: {
  // 	pageResource: 'payment_request_history',
  // 	fieldResource: 'payment_request_history',
  // 	formResource: 'payment_request_history',
  // }
  [PathnameGenerator(PathnameAccounting.PAYMENT_REQUEST)]: {
    pageResource: "sales_invoice",
    fieldResource: "sales_invoice",
    formResource: "sales_invoices",
    permissionKey: "SalesInvoices",
    pageResourceName: "request_payment",
  },
  [PathnameGenerator(PathnameAccounting.CUSTOMER_MANAGEMENT)]: {
    pageResource: "customer_management",
    fieldResource: "parties",
    formResource: "customer_management",
    permissionKey: "Parties",
    pageResourceName: "customer_management",
  },
  [PathnameGenerator(PathnameAccounting.VENDOR_MANAGEMENT)]: {
    pageResource: "vendor_management",
    fieldResource: "parties",
    formResource: "vendor_management",
    permissionKey: "Parties",
    pageResourceName: "vendor_management",
  },
  [PathnameGeneratorCrm(PathnameCrm.CUSTOMER_MANAGEMENT)]: {
    pageResource: "customer_management",
    fieldResource: "parties",
    formResource: "customer_management",
    permissionKey: "CustomerManagement",
    pageResourceName: "customer_management",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.VENDOR_MANAGEMENT)]: {
    pageResource: "vendor_management",
    fieldResource: "parties",
    formResource: "vendor_management",
    permissionKey: "VendorManagement",
    pageResourceName: "vendor_management",
  },
  [PathnameGenerator(PathnameAccounting.BUDGET)]: {
    pageResource: "budgets",
    fieldResource: "budgets",
    formResource: "budgets",
    permissionKey: "Budget",
    pageResourceName: "budget",
  },
  [PathnameGenerator(PathnameAccounting.ASSET_TRANSFER)]: {
    pageResource: "asset_transfers",
    fieldResource: "asset_transfers",
    formResource: "asset_transfers",
    permissionKey: "AssetsTransfer",
    pageResourceName: "asset_transfers",
  },
  [PathnameGenerator(PathnameAccounting.ASSETS_MANAGEMENT)]: {
    pageResource: "assets",
    fieldResource: "assets",
    formResource: "assets",
    permissionKey: "Assets",
    pageResourceName: "assets",
  },
  [PathnameGenerator(PathnameAccounting.COMMISSION_PLAN)]: {
    pageResource: "commission_plan",
    fieldResource: "commission_plans",
    formResource: "commission_plans",
    permissionKey: "CommissionPlans",
    pageResourceName: "commission_plans",
  },
  [PathnameGenerator(PathnameAccounting.COMMISSION_TARGET)]: {
    pageResource: "commission_target",
    fieldResource: "commission_targets",
    formResource: "commission_targets",
    permissionKey: "CommissionTargets",
    pageResourceName: "commission_targets",
  },
  [PathnameGenerator(PathnameAccounting.COMMISSION_ASSIGNMENT)]: {
    pageResource: "commission_assignment",
    fieldResource: "commission_assignments",
    formResource: "commission_assignments",
    permissionKey: "CommissionAssignment",
    pageResourceName: "commission_assignment",
  },
  [PathnameGenerator(PathnameAccounting.AUTHORIZE_COMMISSION)]: {
    pageResource: "commission_authorization",
    fieldResource: "eligible_salesperson_commissions",
    formResource: "eligible_salesperson_commissions",
    permissionKey: "Commission.authorize",
    pageResourceName: "commission_authorised",
  },
  [PathnameGenerator(PathnameAccounting.COMMISSION)]: {
    pageResource: "commission",
    fieldResource: "commissions",
    formResource: "commissions",
    permissionKey: "Commission",
    pageResourceName: "commission",
  },
  [PathnameGenerator(PathnameAccounting.MONTH_WISE_COMMISSION)]: {
    pageResource: "month_wise_commissions",
    fieldResource: "month_wise_commissions",
    formResource: "month_wise_commissions",
    permissionKey: "Commission",
  },
  [PathnameGenerator(PathnameAccounting.PURCHASE_INVOICES)]: {
    pageResource: "purchase_invoice",
    fieldResource: "purchase_invoice",
    formResource: "purchase_invoices",
    permissionKey: "PurchaseInvoices",
    pageResourceName: "purchase_invoice",
  },
  [PathnameGenerator(PathnameAccounting.SALES_INVOICES)]: {
    pageResource: "sales_invoice",
    fieldResource: "sales_invoices",
    formResource: "sales_invoices",
    permissionKey: "SalesInvoices",
    pageResourceName: "sales_invoice",
  },
  [PathnameGenerator(PathnameAccounting.CASH_EXPENSES)]: {
    pageResource: "cash_expense",
    fieldResource: "cash_expenses",
    formResource: "cash_expense",
    permissionKey: "CashExpenses",
    pageResourceName: "cash_expenses",
  },
  [PathnameGenerator(PathnameAccounting.CREDIT_NOTE)]: {
    pageResource: "credit_notes",
    fieldResource: "credit_notes",
    formResource: "credit_notes",
    permissionKey: "CreditNotes",
    pageResourceName: "credit_notes",
  },
  [PathnameGenerator(PathnameAccounting.EXPENSE_REIMBURSEMENT)]: {
    pageResource: "expense_reimbursement",
    fieldResource: "expense_reimbursement",
    formResource: "expense_reimbursements",
    permissionKey: "ExpenseReimbursement",
    pageResourceName: "expense_reimbursements",
  },
  [PathnameGenerator(PathnameAccounting.EXPENSE_REPORT)]: {
    pageResource: "expense_reimbursement",
    fieldResource: "expense_reimbursements",
    formResource: "expense_reimbursements",
    permissionKey: "ExpenseReimbursement",
  },
  [PathnameGenerator(PathnameAccounting.DEBIT_NOTE)]: {
    pageResource: "debit_notes",
    fieldResource: "debit_notes",
    formResource: "debit_notes",
    permissionKey: "DebitNotes",
    pageResourceName: "debit_notes",
  },
  [PathnameGenerator(PathnameAccounting.CHART_OF_ACCOUNTS)]: {
    pageResource: "",
    fieldResource: "chart_of_account",
    formResource: "chart_of_accounts_custom",
    permissionKey: "ChartOf.Account",
    pageResourceName: "chart_of_accounts_custom",
  },
  [PathnameGenerator(PathnameAccounting.CURRENCY)]: {
    pageResource: "",
    fieldResource: "currency",
    formResource: "currency",
    permissionKey: "Currency",
    pageResourceName: "currency",
  },
  [PathnameGenerator(PathnameAccounting.JOURNAL_TYPES)]: {
    pageResource: "",
    fieldResource: "journal_types",
    formResource: "journal_type",
    permissionKey: "JournalTypes",
    pageResourceName: "journal-type",
  },
  [PathnameGenerator(PathnameAccounting.CURRENCY_EXCHANGE)]: {
    pageResource: "",
    fieldResource: "currency_exchange",
    formResource: "currency_exchange",
    permissionKey: "CurrencyExchange",
    pageResourceName: "currency_exchange",
  },
  [PathnameGenerator(PathnameAccounting.TAX_CATEGORY)]: {
    pageResource: "",
    fieldResource: "tax_category",
    formResource: "tax_category",
    permissionKey: "TaxCategory",
    pageResourceName: "tax_category",
  },
  [PathnameGenerator(PathnameAccounting.TAX_CODE)]: {
    pageResource: "",
    fieldResource: "tax_code",
    formResource: "tax_code",
    permissionKey: "TaxCode",
    pageResourceName: "tax_code",
  },
  [PathnameGenerator(PathnameAccounting.TAX_TEMPLATE)]: {
    pageResource: "",
    fieldResource: "tax_templates",
    formResource: "tax_templates",
    permissionKey: "TaxTemplates",
    pageResourceName: "tax_template",
  },
  [PathnameGenerator(PathnameAccounting.BANK)]: {
    pageResource: "",
    fieldResource: "banks",
    formResource: "banks",
    permissionKey: "Banks",
    pageResourceName: "banks",
  },
  [PathnameGenerator(PathnameAccounting.BANK_ACCOUNT)]: {
    pageResource: "",
    fieldResource: "bank_accounts",
    formResource: "bank_accounts",
    permissionKey: "BankAccounts",
    pageResourceName: "bank_accounts",
  },
  [PathnameGenerator(PathnameAccounting.FISCAL_YEAR)]: {
    pageResource: "",
    fieldResource: "fiscal_year",
    formResource: "fiscal_year",
    permissionKey: "FiscalYear",
    pageResourceName: "fiscal_year",
  },
  [PathnameGenerator(PathnameAccounting.PAYMENT_TERMS)]: {
    pageResource: "",
    fieldResource: "payment_terms",
    formResource: "payment_terms",
    permissionKey: "PaymentTerms",
    pageResourceName: "payment_terms",
  },
  [PathnameGenerator(PathnameAccounting.JOURNAL_ITEM)]: {
    pageResource: "journal_item_report",
    fieldResource: "journal_item_report",
    formResource: "journal_item_report",
  },
  [PathnameGenerator(PathnameAccounting.VOUCHER_SETTINGS)]: {
    pageResource: "voucher-settings",
    fieldResource: "voucher-settings",
    formResource: "voucher-settings",
    pageResourceName: "voucher-settings",
  },
  [PathnameGeneratorInventory(PathnameInventory.ITEM)]: {
    pageResource: "inventory-item",
    fieldResource: "inventory_items",
    formResource: "inventory_items",
    permissionKey: "InventoryItems",
    pageResourceName: "inventory_items",
  },
  [PathnameGeneratorInventory(PathnameInventory.ITEM_CATEGORY)]: {
    pageResource: "",
    fieldResource: "category_items",
    formResource: "category_items",
    permissionKey: "CategoryItems",
    pageResourceName: "item_category",
  },
  [PathnameGeneratorInventory(PathnameInventory.DISCOUNTED_ITEM)]: {
    pageResource: "",
    fieldResource: "discount_items",
    formResource: "discount_items",
    permissionKey: "DiscountItems",
    pageResourceName: "discount_items",
  },
  [PathnameGeneratorInventory(PathnameInventory.ATTRIBUTES)]: {
    pageResource: "",
    fieldResource: "attributes",
    formResource: "attributes",
    permissionKey: "Attributes",
    pageResourceName: "attributes",
  },
  [PathnameGeneratorInventory(PathnameInventory.LOCATION)]: {
    pageResource: "",
    fieldResource: "warehouse_location",
    formResource: "warehouse_location",
    permissionKey: "WarehouseLocation",
    pageResourceName: "warehouse_location",
  },
  [PathnameGeneratorInventory(PathnameInventory.ROUTE_RULES)]: {
    pageResource: "",
    fieldResource: "routes_rules",
    formResource: "routes_rules",
    permissionKey: "RoutesRules",
  },
  [PathnameGeneratorInventory(PathnameInventory.BINS)]: {
    pageResource: "",
    fieldResource: "bins",
    formResource: "bins",
    permissionKey: "Bin",
    pageResourceName: "bins",
  },
  [PathnameGeneratorInventory(PathnameInventory.UOM)]: {
    pageResource: "",
    fieldResource: "uom",
    formResource: "units_of_measurement",
    permissionKey: "Uom.templates",
    pageResourceName: "uom",
  },
  [PathnameGeneratorInventory(PathnameInventory.STOCK_TRANSFER)]: {
    pageResource: "",
    fieldResource: "stock_transfers",
    formResource: "stock_transfers",
    permissionKey: "StockTransfers",
    pageResourceName: "stock_transfer",
  },
  [PathnameGeneratorInventory(PathnameInventory.BIN_TRANSFER)]: {
    pageResource: "",
    fieldResource: "bin_transfer",
    formResource: "bin_transfer",
    permissionKey: "BinTransfer",
    pageResourceName: "bin_transfer",
  },
  [PathnameGeneratorInventory(PathnameInventory.SCRAP)]: {
    pageResource: "",
    fieldResource: "scrap",
    formResource: "scrap",
    permissionKey: "Scra",
    pageResourceName: "scrap",
  },
  [PathnameGeneratorInventory(PathnameInventory.INVENTORY_ADJUSTMENT)]: {
    pageResource: "",
    fieldResource: "inventory_adjustment",
    formResource: "inventory_adjustment",
    permissionKey: "InventoryAdjustment",
    pageResourceName: "inventory_adjustment",
  },
  // New Inventory Reports (10 reports)
  [PathnameGeneratorInventory(PathnameInventory.STOCK_RECONCILIATION)]: {
    pageResource: "inv_stock_reconciliation_report",
    fieldResource: "inv_stock_reconciliation_report",
    formResource: "inv_stock_reconciliation_report",
  },
  [PathnameGeneratorInventory(PathnameInventory.SLOW_MOVING_INVENTORY)]: {
    pageResource: "inv_slow_moving_inventory_report",
    fieldResource: "inv_slow_moving_inventory_report",
    formResource: "inv_slow_moving_inventory_report",
  },
  [PathnameGeneratorInventory(PathnameInventory.WAREHOUSE_STOCK_AGING)]: {
    pageResource: "inv_warehouse_stock_aging_report",
    fieldResource: "inv_warehouse_stock_aging_report",
    formResource: "inv_warehouse_stock_aging_report",
  },
  [PathnameGeneratorInventory(PathnameInventory.WAREHOUSE_TRANSFERS)]: {
    pageResource: "inv_warehouse_transfers_report",
    fieldResource: "inv_warehouse_transfers_report",
    formResource: "inv_warehouse_transfers_report",
  },
  [PathnameGeneratorInventory(PathnameInventory.RETURN_TO_VENDOR)]: {
    pageResource: "inv_return_to_vendor_report",
    fieldResource: "inv_return_to_vendor_report",
    formResource: "inv_return_to_vendor_report",
  },
  [PathnameGeneratorInventory(PathnameInventory.INVENTORY_AGING)]: {
    pageResource: "inv_inventory_aging_report",
    fieldResource: "inv_inventory_aging_report",
    formResource: "inv_inventory_aging_report",
  },
  [PathnameGeneratorInventory(PathnameInventory.INVENTORY_COST_ANALYSIS)]: {
    pageResource: "inv_inventory_cost_analysis_report",
    fieldResource: "inv_inventory_cost_analysis_report",
    formResource: "inv_inventory_cost_analysis_report",
  },
  [PathnameGeneratorInventory(PathnameInventory.STOCK_MOVEMENT_TURNOVER)]: {
    pageResource: "inv_stock_movement_turnover_report",
    fieldResource: "inv_stock_movement_turnover_report",
    formResource: "inv_stock_movement_turnover_report",
  },
  [PathnameGeneratorInventory(PathnameInventory.STOCK_ON_HAND)]: {
    pageResource: "inv_stock_on_hand_report",
    fieldResource: "inv_stock_on_hand_report",
    formResource: "inv_stock_on_hand_report",
  },
  [PathnameGeneratorInventory(PathnameInventory.STOCK_RESERVATION)]: {
    pageResource: "inv_stock_reservation_report",
    fieldResource: "inv_stock_reservation_report",
    formResource: "inv_stock_reservation_report",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.BILL_OF_MATERIALS)]: {
    pageResource: "mf_bom",
    fieldResource: "bills-of-materials",
    formResource: "mf_bom",
    permissionKey: "BillsOf.Materials",
    pageResourceName: "mf_bom",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.GATE_REGISTER)]: {
    pageResource: "mf_gate",
    fieldResource: "gate_register",
    formResource: "mf_gate",
    permissionKey: "GateRegister",
    pageResourceName: "mf_gate",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.JOB_CARDS)]: {
    pageResource: "job_cards",
    fieldResource: "mf_job_cards",
    formResource: "mf_job_cards",
    permissionKey: "JobCards",
    pageResourceName: "mf_job_cards",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.MASTER_JOB_CARD)]: {
    pageResource: "mf_master_job_cards",
    fieldResource: "mf_master_job_cards",
    formResource: "mf_master_job_cards",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.WORK_ORDER)]: {
    pageResource: "mf_work_orders",
    fieldResource: "mf_work_orders",
    formResource: "mf_work_orders",
    permissionKey: "WorkOrder",
    pageResourceName: "mf_work_orders",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.BUILD_ORDER)]: {
    pageResource: "build_order",
    fieldResource: "mf_build_orders",
    formResource: "mf_build_orders",
    permissionKey: "BuildOrders",
    pageResourceName: "mf_build_orders",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.UNBUILD_ORDER)]: {
    pageResource: "unbuild_order",
    fieldResource: "unbuild_orders",
    formResource: "mf_unbuild_orders",
    permissionKey: "UnbuildOrders",
    pageResourceName: "mf_unbuild_orders",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.MANAGE_OPERATIONS)]: {
    pageResource: "mf_work_orders",
    fieldResource: "mf_work_orders",
    formResource: "mf_work_orders",
    pageResourceName: "mf_manage_operations",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.OPERATION_BLOCKS)]: {
    pageResource: "mf_operation_blocks",
    fieldResource: "operation_block",
    formResource: "mf_operation_blocks",
    permissionKey: "OperationBlock",
    pageResourceName: "mf_operations_block",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.EQUIPMENT_FAILURE)]: {
    pageResource: "mf_equipment_failure",
    fieldResource: "mf_equipment_failures",
    formResource: "mf_equipment_failures",
    permissionKey: "Equipments.failures",
    pageResourceName: "mf_equipment_failure",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.OPERATIONS)]: {
    pageResource: "operation",
    fieldResource: "operations",
    formResource: "mf_operations",
    permissionKey: "Operations",
    pageResourceName: "mf_operations",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.WORK_CENTERS)]: {
    pageResource: "work_center",
    fieldResource: "work_centre",
    formResource: "mf_work_centres",
    permissionKey: "WorkCentre",
    pageResourceName: "mf_work_centres",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.EQUIPMENTS)]: {
    pageResource: "equipment",
    fieldResource: "equipments",
    formResource: "mf_equipments",
    permissionKey: "Equipments",
    pageResourceName: "mf_equipments",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.WORK_CENTER_CATEGORIES)]:
  {
    pageResource: "work_center_category",
    fieldResource: "work_centre_categories",
    formResource: "mf_work_centre_categories",
    permissionKey: "WorkCentre.Categories",
    pageResourceName: "mf_work_centre_categories",
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.ROUTING)]: {
    pageResource: "routing",
    fieldResource: "routing",
    formResource: "mf_routing",
    permissionKey: "Routing",
    pageResourceName: "mf_routing",
  },
  [PathnameGeneratorCrm(PathnameCrm.LEAD)]: {
    pageResource: "leads",
    fieldResource: "sl_leads",
    formResource: "sl_leads",
    permissionKey: "Lead",
    pageResourceName: "sales_lead",
  },
  [PathnameGeneratorCrm(PathnameCrm.OPPORTUNITY)]: {
    pageResource: "sl_opportunity",
    fieldResource: "sl_opportunity_parties",
    formResource: "sl_opportunity_parties",
    permissionKey: "Opportunity",
    pageResourceName: "sales_opportunity",
  },
  [PathnameGeneratorCrm(PathnameCrm.QUOTATION)]: {
    pageResource: "sl_quotation",
    fieldResource: "sl_quotation",
    formResource: "sl_quotation",
    permissionKey: "Quotation",
    pageResourceName: "sales_quotation",
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_ORDER)]: {
    pageResource: "sl_sales_order",
    fieldResource: "sl_sales_orders",
    formResource: "sl_sales_orders",
    permissionKey: "SalesOrders",
    pageResourceName: "sales_orders_import",
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_ORDER_DETAIL_REPORT)]: {
    pageResource: "sl_sales_order_detail_report",
    fieldResource: "sl_sales_order_detail_report",
    formResource: "sl_sales_order_detail_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_ORDER_SUMMARY_REPORT)]: {
    pageResource: "sl_sales_order_summary_report",
    fieldResource: "sl_sales_order_summary_report",
    formResource: "sl_sales_order_summary_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_INVOICE_SUMMARY_REPORT)]: {
    pageResource: "sl_sales_invoice_summary_report",
    fieldResource: "sl_sales_invoice_summary_report",
    formResource: "sl_sales_invoice_summary_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_INVOICE_DETAIL_REPORT)]: {
    pageResource: "sl_sales_invoice_detail_report",
    fieldResource: "sl_sales_invoice_detail_report",
    formResource: "sl_sales_invoice_detail_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_BY_SALESPERSON_PERFORMANCE)]: {
    pageResource: "sl_sales_by_salesperson_performance_report",
    fieldResource: "sl_sales_by_salesperson_performance_report",
    formResource: "sl_sales_by_salesperson_performance_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.PENDING_QUOTES_APPROVALS)]: {
    pageResource: "sl_pending_quotes_approvals_report",
    fieldResource: "sl_pending_quotes_approvals_report",
    formResource: "sl_pending_quotes_approvals_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_RETURN_CREDIT_NOTE_REPORT)]: {
    pageResource: "sl_sales_return_credit_note_report",
    fieldResource: "sl_sales_return_credit_note_report",
    formResource: "sl_sales_return_credit_note_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.REGIONAL_BRANCH_SALES_PERFORMANCE)]: {
    pageResource: "sl_regional_branch_sales_performance_report",
    fieldResource: "sl_regional_branch_sales_performance_report",
    formResource: "sl_regional_branch_sales_performance_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_DISCOUNT_PROMOTION_ANALYSIS)]: {
    pageResource: "sl_sales_discount_promotion_analysis_report",
    fieldResource: "sl_sales_discount_promotion_analysis_report",
    formResource: "sl_sales_discount_promotion_analysis_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_CHANNEL_ANALYSIS)]: {
    pageResource: "sl_sales_channel_analysis_report",
    fieldResource: "sl_sales_channel_analysis_report",
    formResource: "sl_sales_channel_analysis_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.ORDER_FULFILLMENT_DELIVERY_REPORT)]: {
    pageResource: "sl_order_fulfillment_delivery_report",
    fieldResource: "sl_order_fulfillment_delivery_report",
    formResource: "sl_order_fulfillment_delivery_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_COMMISSION_INCENTIVE_REPORT)]: {
    pageResource: "sl_sales_commission_incentive_report",
    fieldResource: "sl_sales_commission_incentive_report",
    formResource: "sl_sales_commission_incentive_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.CUSTOMER_CHURN_RETENTION_REPORT)]: {
    pageResource: "sl_customer_churn_retention_report",
    fieldResource: "sl_customer_churn_retention_report",
    formResource: "sl_customer_churn_retention_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_BY_PRODUCT_SERVICE_REPORT)]: {
    pageResource: "sl_sales_by_product_report",
    fieldResource: "sl_sales_by_product_report",
    formResource: "sl_sales_by_product_report",
  },
  [PathnameGeneratorCrm(PathnameCrm.DELIVERTY_ORDER)]: {
    pageResource: "sl_delivery_order",
    fieldResource: "sl_delivery_orders",
    formResource: "sl_delivery_orders",
    permissionKey: "DeliveryOrders",
    pageResourceName: "delivery_orders",
  },
  [PathnameGeneratorCrm(PathnameCrm.CUSTOMER_RETURNS)]: {
    pageResource: "sl_customer_return",
    fieldResource: "customer_returns",
    formResource: "customer_returns",
    permissionKey: "CustomerReturns",
    pageResourceName: "customer_returns_import",
  },
  [PathnameGeneratorCrm(PathnameCrm.SHIPMENT_RULES)]: {
    pageResource: "shippment_rules",
    fieldResource: "sl_shipping_rules",
    formResource: "sl_shipping_rules",
    permissionKey: "ShippingRules",
    pageResourceName: "shipping_rules",
  },
  [PathnameGeneratorCrm(PathnameCrm.PROMOTIONS)]: {
    pageResource: "sl_promotions",
    fieldResource: "sl_promotions",
    formResource: "sl_promotions",
    permissionKey: "Promotion",
    pageResourceName: "promotions",
  },
  [PathnameGeneratorCrm(PathnameCrm.CUSTOMER_SEGMENTS)]: {
    pageResource: "customer_segments",
    fieldResource: "customer_segment",
    formResource: "customer_segment",
    permissionKey: "CustomerSegment",
    pageResourceName: "customer_segments",
  },
  [PathnameGeneratorCrm(PathnameCrm.TERMS_AND_CONDITIONS)]: {
    pageResource: "",
    fieldResource: "sl_terms_and_conditions",
    formResource: "sl_terms_and_conditions",
    defaultColumns: crmTermsAndConditionsColumns,
    permissionKey: "SalesTerms.Conditions",
    pageResourceName: "terms_and_conditions",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.TERMS_AND_CONDITIONS)]: {
    pageResource: "purchase_terms_and_conditions",
    fieldResource: "pr_terms_and_conditions",
    formResource: "pr_terms_and_conditions",
    defaultColumns: purchaseTermsAndConditionsColumns,
    permissionKey: "PurchaseTerms.AndConditions",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.REQUESTS)]: {
    pageResource: "purchase-request",
    fieldResource: "pr_purchase_requests",
    formResource: "pr_purchase_requests",
    permissionKey: "PurchaseRequests",
    pageResourceName: "purchase_requests_import",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_AGREEMENT)]: {
    pageResource: "purchase_agreement",
    fieldResource: "pr_purchase_agreements",
    formResource: "pr_purchase_agreements",
    permissionKey: "PurchaseAgreements",
    pageResourceName: "purchase_agreements_import",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.RFQ)]: {
    pageResource: "request_for_quote",
    fieldResource: "pr_rfqs",
    formResource: "pr_rfqs",
    permissionKey: "Rfq",
    pageResourceName: "request_for_quote_import",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_ORDER)]: {
    pageResource: "purchase_order",
    fieldResource: "pr_purchase_orders",
    formResource: "pr_purchase_orders",
    permissionKey: "PurchaseOrders",
    pageResourceName: "purchase_order_import",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.VENDOR_RETURNS)]: {
    pageResource: "purchase_vendor_returns",
    fieldResource: "pr_vras",
    formResource: "pr_vras",
    permissionKey: "Vra",
    pageResourceName: "vendor_return_import",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.DELIVERY_ORDER)]: {
    pageResource: "purchase_delivery_order",
    fieldResource: "pr_delivery_orders",
    formResource: "pr_delivery_orders",
    permissionKey: "DeliveryOrders",
    pageResourceName: "delivery_order",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.LANDED_COST)]: {
    pageResource: "purchase_landed_cost",
    fieldResource: "pr_landed_cost",
    formResource: "pr_landed_cost",
    permissionKey: "LandingCost",
    pageResourceName: "landing_cost_import",
  },
  // Procurement Reports
  [PathnameGeneratorPurchase(PathnamePurchase.APPROVED_VS_PENDING_PO)]: {
    pageResource: "pr_approved_vs_pending_po_report",
    fieldResource: "pr_approved_vs_pending_po_report",
    formResource: "pr_approved_vs_pending_po_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.MATERIAL_REQUIREMENT_EXCEPTION)]: {
    pageResource: "pr_material_requirement_exception_report",
    fieldResource: "pr_material_requirement_exception_report",
    formResource: "pr_material_requirement_exception_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.SUPPLIER_CONTRACT_COMPLIANCE)]: {
    pageResource: "pr_supplier_contract_compliance_report",
    fieldResource: "pr_supplier_contract_compliance_report",
    formResource: "pr_supplier_contract_compliance_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.SUPPLIER_RANKING_SCORECARD)]: {
    pageResource: "pr_supplier_ranking_scorecard_report",
    fieldResource: "pr_supplier_ranking_scorecard_report",
    formResource: "pr_supplier_ranking_scorecard_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_RETURN_REPORT)]: {
    pageResource: "pr_purchase_return_report",
    fieldResource: "pr_purchase_return_report",
    formResource: "pr_purchase_return_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_ORDER_CANCELLATION)]: {
    pageResource: "pr_purchase_order_cancellation_report",
    fieldResource: "pr_purchase_order_cancellation_report",
    formResource: "pr_purchase_order_cancellation_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_ORDER_SUMMARY_REPORT)]: {
    pageResource: "pr_purchase_order_summary_report",
    fieldResource: "pr_purchase_order_summary_report",
    formResource: "pr_purchase_order_summary_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_ORDER_DETAIL_REPORT)]: {
    pageResource: "pr_purchase_order_detail_report",
    fieldResource: "pr_purchase_order_detail_report",
    formResource: "pr_purchase_order_detail_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_TREND_REPORT)]: {
    pageResource: "pr_purchase_trend_report",
    fieldResource: "pr_purchase_trend_report",
    formResource: "pr_purchase_trend_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.RECEIVED_VS_ORDERED_REPORT)]: {
    pageResource: "pr_received_vs_ordered_report",
    fieldResource: "pr_received_vs_ordered_report",
    formResource: "pr_received_vs_ordered_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.SUPPLIER_AGING_PAYABLE_REPORT)]: {
    pageResource: "pr_supplier_aging_payable_report",
    fieldResource: "pr_supplier_aging_payable_report",
    formResource: "pr_supplier_aging_payable_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_PRICE_VARIANCE_REPORT)]: {
    pageResource: "pr_purchase_price_variance_report",
    fieldResource: "pr_purchase_price_variance_report",
    formResource: "pr_purchase_price_variance_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.OPEN_PURCHASE_ORDER_REPORT)]: {
    pageResource: "pr_open_purchase_order_report",
    fieldResource: "pr_open_purchase_order_report",
    formResource: "pr_open_purchase_order_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_INVOICE_SUMMARY_REPORT)]: {
    pageResource: "pr_purchase_invoice_summary_report",
    fieldResource: "pr_purchase_invoice_summary_report",
    formResource: "pr_purchase_invoice_summary_report",
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_INVOICE_DETAIL_REPORT)]: {
    pageResource: "pr_purchase_invoice_detail_report",
    fieldResource: "pr_purchase_invoice_detail_report",
    formResource: "pr_purchase_invoice_detail_report",
  },
  [PathnameGeneratorUsers(PathnameUsers.USER)]: {
    pageResource: "user",
    fieldResource: "user",
    formResource: "user",
    permissionKey: "User",
  },
  [PathnameGeneratorUsers(PathnameUsers.LANGUAGE)]: {
    pageResource: "language",
    fieldResource: "languages",
    formResource: "languages",
  },

  // Rental Module
  [PathnameGeneratorRental(PathnameRental.TERMS_AND_CONDITIONS)]: {
    pageResource: "",
    fieldResource: "rn_terms_and_conditions",
    formResource: "rn_terms_and_conditions",
    permissionKey: "RentalTerms.Conditions",
    pageResourceName: "terms_and_conditions",
  },
  [PathnameGeneratorRental(PathnameRental.CONFIGURATIONS)]: {
    pageResource: "configuration",
    fieldResource: "configuration",
    formResource: "configuration",
    permissionKey: "RentalSettings",
  },
  [PathnameGeneratorRental(PathnameRental.BILLING_CYCLE)]: {
    pageResource: "",
    fieldResource: "rn_billing_cycles",
    formResource: "rn_billing_cycles",
    permissionKey: "RentalBilling.Cycles",
    pageResourceName: "billing_cycle_import",
  },
  [PathnameGeneratorRental(PathnameRental.LEADS)]: {
    fieldResource: "sl_leads",
    pageResource: "rental_leads",
    formResource: "rental_leads",
    permissionKey: "RentalLead",
    pageResourceName: "rental_lead",
  },
  [PathnameGeneratorRental(PathnameRental.OPPORTUNITY)]: {
    fieldResource: "sl_opportunity_parties",
    pageResource: "rental_opportunity",
    formResource: "rn_opportunity_parties",
    permissionKey: "RentalOpportunity",
    pageResourceName: "rental_opportunity_import",
  },
  [PathnameGeneratorRental(PathnameRental.QUOTATION)]: {
    pageResource: "rental_quotation",
    fieldResource: "sl_quotation",
    formResource: "rn_quotation",
    permissionKey: "RentalQuotations",
    pageResourceName: "rental_quotation_import",
  },
  [PathnameGeneratorRental(PathnameRental.REVISED_QUOTATION)]: {
    pageResource: "",
    fieldResource: "sl_quotation",
    formResource: "rn_quotation",
    permissionKey: "RentalQuotations",
  },
  [PathnameGeneratorRental(PathnameRental.AGREEMENTS)]: {
    pageResource: "rental_agreement",
    fieldResource: "pr_purchase_agreements",
    formResource: "rental_agreement",
    permissionKey: "RentalAgreements",
    pageResourceName: "rn_agreements_import",
  },
  [PathnameGeneratorRental(PathnameRental.CROSS_HIRE_REQUESTS)]: {
    pageResource: "rental_cross_hire_request",
    fieldResource: "pr_purchase_requests",
    formResource: "rn_request",
    permissionKey: "CrossHire.Requests",
    pageResourceName: "cross_hire_requests_import",
  },
  [PathnameGeneratorRental(PathnameRental.CROSS_HIRE_RFQ)]: {
    pageResource: "rn_cross_hire_request_for_quote",
    fieldResource: "pr_rfqs",
    formResource: "rn_cross_hire_request_for_quote",
    permissionKey: "CrossHire.Rfq",
    pageResourceName: "cross_hire_rfq_import",
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_ORDERS)]: {
    pageResource: "rental_order",
    fieldResource: "sl_sales_orders",
    formResource: "rn_rental_order",
    permissionKey: "RentalOrders",
    pageResourceName: "rental_orders_import",
  },
  [PathnameGeneratorRental(PathnameRental.PURCHASE_REQUEST_FOR_QUOTE)]: {
    pageResource: "request_for_quote",
    fieldResource: "pr_rfqs",
    formResource: "pr_rfqs",
    pageResourceName: "request_for_quote_import",
  },
  [PathnameGeneratorRental(PathnameRental.PURCHASE_ORDERS)]: {
    pageResource: "purchase_order",
    fieldResource: "pr_purchase_orders",
    formResource: "pr_purchase_orders",
    pageResourceName: "purchase_order_import",
  },
  [PathnameGeneratorRental(PathnameRental.CROSS_HIRE_ORDERS)]: {
    pageResource: "rental_cross_hire_order",
    fieldResource: "pr_purchase_orders",
    formResource: "rn_order",
    permissionKey: "CrossHire.Orders",
    pageResourceName: "cross_hire_order_import",
  },
  [PathnameGeneratorRental(PathnameRental.INVOICING_PREVIOUS_JOBS)]: {
    pageResource: "rn_invoice_jobs",
    fieldResource: "rn_invoice_jobs",
    formResource: "rn_invoice_jobs",
    permissionKey: "InvoiceRental.Jobs",
  },
  [PathnameGeneratorRental(PathnameRental.ITEM)]: {
    pageResource: "inventory-item",
    fieldResource: "inventory_items",
    formResource: "inventory_items",
    permissionKey: "InventoryItems",
    pageResourceName: "inventory_items",
  },
  [PathnameGeneratorRental(PathnameRental.ITEM_CATEGORY)]: {
    pageResource: "",
    fieldResource: "category_items",
    formResource: "category_items",
    permissionKey: "CategoryItems",
    pageResourceName: "item_category",
  },

  // Rental Reports
  [PathnameGeneratorRental(PathnameRental.RENTAL_REVENUE_REPORT)]: {
    pageResource: "rn_rental_revenue_report",
    fieldResource: "rn_rental_revenue_report",
    formResource: "rn_rental_revenue_report",
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_AGREEMENT_REPORT)]: {
    pageResource: "rn_rental_agreement_report",
    fieldResource: "rn_rental_agreement_report",
    formResource: "rn_rental_agreement_report",
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_AGREEMENT_DETAIL_REPORT)]: {
    pageResource: "rn_rental_agreement_detail_report",
    fieldResource: "rn_rental_agreement_detail_report",
    formResource: "rn_rental_agreement_detail_report",
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_ASSET_RETURN_REPORT)]: {
    pageResource: "rn_rental_asset_return_report",
    fieldResource: "rn_rental_asset_return_report",
    formResource: "rn_rental_asset_return_report",
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_CANCELLATIONS_AMENDMENTS_REPORT)]: {
    pageResource: "rn_rental_cancellations_amendments_report",
    fieldResource: "rn_rental_cancellations_amendments_report",
    formResource: "rn_rental_cancellations_amendments_report",
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_PAYMENT_AGING_REPORT)]: {
    pageResource: "rn_rental_payment_aging_report",
    fieldResource: "rn_rental_payment_aging_report",
    formResource: "rn_rental_payment_aging_report",
  },
  [PathnameGeneratorRental(PathnameRental.ACTIVE_RENTALS_REPORT)]: {
    pageResource: "rn_active_rentals_report",
    fieldResource: "rn_active_rentals_report",
    formResource: "rn_active_rentals_report",
  },
  [PathnameGeneratorRental(PathnameRental.UPCOMING_EXPIRY_REPORT)]: {
    pageResource: "rn_upcoming_expiry_report",
    fieldResource: "rn_upcoming_expiry_report",
    formResource: "rn_upcoming_expiry_report",
  },
  [PathnameGeneratorRental(PathnameRental.ASSET_AVAILABILITY_REPORT)]: {
    pageResource: "rn_asset_availability_report",
    fieldResource: "rn_asset_availability_report",
    formResource: "rn_asset_availability_report",
  },
  [PathnameGeneratorRental(PathnameRental.ASSET_UTILIZATION_REPORT)]: {
    pageResource: "rn_asset_utilization_report",
    fieldResource: "rn_asset_utilization_report",
    formResource: "rn_asset_utilization_report",
  },
  [PathnameGeneratorRental(PathnameRental.ASSET_CATEGORY_PERFORMANCE_REPORT)]: {
    pageResource: "rn_asset_category_performance_report",
    fieldResource: "rn_asset_category_performance_report",
    formResource: "rn_asset_category_performance_report",
  },
  [PathnameGeneratorRental(PathnameRental.CUSTOMER_RENTAL_REPORT)]: {
    pageResource: "rn_customer_rental_report",
    fieldResource: "rn_customer_rental_report",
    formResource: "rn_customer_rental_report",
  },
  [PathnameGeneratorHrms(PathnameHrms.APPROVAL_WORKFLOW)]: {
    pageResource: "",
    fieldResource: "",
    formResource: "",
  },
  ...(Object.values(Pathname).reduce((acc, path) => {
    acc[`${path}${TEMPLATE_EDITOR_PATHS.TEMPLATES_LIST('email')}`] = {
      pageResource: "",
      fieldResource: "subjects",
    };
    acc[`${path}${TEMPLATE_EDITOR_PATHS.TEMPLATES_LIST('pdf')}`] = {
      pageResource: "",
      fieldResource: "subjects",
    };
    return acc;
  }, {})),
  // [PathnameGeneratorUsers(PathnameUsers.EMAILS)]: {
  //   pageResource: "",
  //   fieldResource: "subjects",
  // },

  // HRMS Module
  [PathnameGeneratorHrms(PathnameHrms.LOAN_CONFIGURATION)]: {
    pageResource: "",
    fieldResource: "loan_master",
    formResource: "loan_master",
  },
  [PathnameGeneratorHrms(PathnameHrms.DOCUMENT_MASTER)]: {
    pageResource: "",
    fieldResource: "document_master",
    formResource: "document_master",
  },
  [PathnameGeneratorHrms(PathnameHrms.COMPANY_CALENDAR)]: {
    pageResource: "",
    fieldResource: "company_calendar",
    formResource: "company_calendar",
  },
  [PathnameGeneratorHrms(PathnameHrms.LEAVE_POLICY_MASTER)]: {
    pageResource: "",
    fieldResource: "leave_policy_master",
    formResource: "leave_policy_master",
  },
  [PathnameGeneratorHrms(PathnameHrms.SALARY_STRUCTURE_MASTER)]: {
    pageResource: "",
    fieldResource: "salary_structure_master",
    formResource: "salary_structure_master",
  },
  [PathnameGeneratorHrms(PathnameHrms.EMPLOYEE_MANAGEMENT)]: {
    pageResource: "",
    fieldResource: "employees",
    formResource: "",
  },
  // [PathnameGeneratorHrms(PathnameHrms.EMPLOYEE_CONTRACT)]: {
  //   pageResource: "",
  //   fieldResource: "employee_contracts",
  //   formResource: "employee_contracts",
  // },
  // [PathnameGeneratorHrms(PathnameHrms.EMPLOYEE_LEAVE)]: {
  //   pageResource: "",
  //   fieldResource: "employee_leaves",
  //   formResource: "employee_leaves",
  // },
  // [PathnameGeneratorHrms(PathnameHrms.EMPLOYEE_LEAVE_REQUEST)]: {
  //   pageResource: "",
  //   fieldResource: "employee_leave_requests",
  //   formResource: "",
  // },
};

export const breadcrumbSegmentLabelMap: Record<string, string> = {
  "active-rentals-report": "Active Rentals Report",
  "asset-availability-report": "Asset Availability Report",
  "asset-category-performance-report": "Asset Category Performance Report",
  "asset-utilization-report": "Asset Utilization Report",
  "customer-rental-report": "Customer Rental Report",
  "rental-agreement-detail-report": "Order Detail Report",
  "rental-agreement-report": "Agreement Report",
  "rental-asset-return-report": "Asset Return Report",
  "rental-cancellations-amendments-report": "Cancellations Report",
  "rental-payment-aging-report": "Payment Aging Report",
  "rental-revenue-report": "Revenue Report",
  "upcoming-expiry-report": "Upcoming Expiry Report",
};


// Default columns for each route
export const routeToColumnsMap: Record<string, IColumns> = {
  [PathnameGenerator(PathnameAccounting.JOURNAL_ENTRY)]: {
    defaultColumns: journalEntryColumns,
  },
  [PathnameGenerator(PathnameAccounting.JOURNAL_ITEM)]: {
    defaultColumns: journalItemReportColumns,
  },
  [PathnameGenerator(PathnameAccounting.PAYMENT)]: {
    defaultColumns: paymentColumns,
  },
  [PathnameGenerator(PathnameAccounting.COLLECTION)]: {
    defaultColumns: collectionColumns,
  },
  // [PathnameGenerator(PathnameAccounting.PAYMENT_REQUEST)]: {
  // defaultColumns: []
  // }
  [PathnameGenerator(PathnameAccounting.PAYMENT_REQUEST)]: {
    defaultColumns: paymentRequestColumns,
  },
  [PathnameGenerator(PathnameAccounting.CUSTOMER_MANAGEMENT)]: {
    defaultColumns: customerManagementColumns,
  },
  [PathnameGenerator(PathnameAccounting.VENDOR_MANAGEMENT)]: {
    defaultColumns: vendorManagementColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.CUSTOMER_MANAGEMENT)]: {
    defaultColumns: customerManagementColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.VENDOR_MANAGEMENT)]: {
    defaultColumns: vendorManagementColumns,
  },
  [PathnameGenerator(PathnameAccounting.BUDGET)]: {
    defaultColumns: budgetColumns,
  },
  [PathnameGenerator(PathnameAccounting.ASSET_TRANSFER)]: {
    defaultColumns: assetTransferColumns,
  },
  [PathnameGenerator(PathnameAccounting.ASSETS_MANAGEMENT)]: {
    defaultColumns: assetManagementColumns,
  },
  [PathnameGenerator(PathnameAccounting.COMMISSION_PLAN)]: {
    defaultColumns: commissionPlanColumns,
  },
  [PathnameGenerator(PathnameAccounting.COMMISSION_TARGET)]: {
    get defaultColumns() { return getCommissionTargetColumns(); },
  },
  [PathnameGenerator(PathnameAccounting.COMMISSION_ASSIGNMENT)]: {
    defaultColumns: commissionAssignmentColumns,
  },
  [PathnameGenerator(PathnameAccounting.MONTH_WISE_COMMISSION)]: {
    defaultColumns: monthWiseCommissionColumns,
  },
  [PathnameGenerator(PathnameAccounting.AUTHORIZE_COMMISSION)]: {
    defaultColumns: commissionAuthorizationColumns,
  },
  [PathnameGenerator(PathnameAccounting.COMMISSION)]: {
    defaultColumns: commissionColumns,
  },
  [PathnameGenerator(PathnameAccounting.PURCHASE_INVOICES)]: {
    defaultColumns: purchaseInvoiceColumns,
  },
  [PathnameGenerator(PathnameAccounting.SALES_INVOICES)]: {
    defaultColumns: salesInvoiceColumns,
  },
  [PathnameGenerator(PathnameAccounting.CASH_EXPENSES)]: {
    defaultColumns: cashExpensesColumns,
  },
  [PathnameGenerator(PathnameAccounting.CREDIT_NOTE)]: {
    defaultColumns: creditNoteColumns,
  },
  [PathnameGenerator(PathnameAccounting.DEBIT_NOTE)]: {
    defaultColumns: debitNoteColumns,
  },
  [PathnameGenerator(PathnameAccounting.EXPENSE_REIMBURSEMENT)]: {
    defaultColumns: expenseReimbursementColumns,
  },
  [PathnameGenerator(PathnameAccounting.EXPENSE_REPORT)]: {
    defaultColumns: expenseReportsColumns,
  },
  [PathnameGenerator(PathnameAccounting.CHART_OF_ACCOUNTS)]: {
    defaultColumns: chartOfAccountsColumns,
  },
  [PathnameGenerator(PathnameAccounting.CURRENCY)]: {
    defaultColumns: currencyColumns,
  },
  [PathnameGenerator(PathnameAccounting.JOURNAL_TYPES)]: {
    defaultColumns: journalTypeColumns,
  },
  [PathnameGenerator(PathnameAccounting.CURRENCY_EXCHANGE)]: {
    defaultColumns: currencyExchangeColumns,
  },
  [PathnameGenerator(PathnameAccounting.TAX_CATEGORY)]: {
    defaultColumns: taxCategoryColumns,
  },
  [PathnameGenerator(PathnameAccounting.TAX_CODE)]: {
    defaultColumns: taxCodeColumns,
  },
  [PathnameGenerator(PathnameAccounting.TAX_TEMPLATE)]: {
    defaultColumns: taxTemplateColumns,
  },
  [PathnameGenerator(PathnameAccounting.BANK)]: {
    defaultColumns: bankColumns,
  },
  [PathnameGenerator(PathnameAccounting.BANK_ACCOUNT)]: {
    defaultColumns: bankAccountColumns,
  },
  [PathnameGenerator(PathnameAccounting.FISCAL_YEAR)]: {
    defaultColumns: fiscalYearColumns,
  },
  [PathnameGenerator(PathnameAccounting.PAYMENT_TERMS)]: {
    defaultColumns: paymentTermsColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.ITEM)]: {
    defaultColumns: inventoryItemColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.ITEM_CATEGORY)]: {
    defaultColumns: itemCategoryColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.DISCOUNTED_ITEM)]: {
    defaultColumns: discountedItemsColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.ATTRIBUTES)]: {
    defaultColumns: attributesColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.LOCATION)]: {
    defaultColumns: locationColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.ROUTE_RULES)]: {
    defaultColumns: routeRulesColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.BINS)]: {
    defaultColumns: binsColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.UOM)]: {
    defaultColumns: uomColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.STOCK_TRANSFER)]: {
    defaultColumns: stockTransferColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.BIN_TRANSFER)]: {
    defaultColumns: binTransferColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.SCRAP)]: {
    defaultColumns: scrapColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.INVENTORY_ADJUSTMENT)]: {
    defaultColumns: inventoryAdjustmentColumns,
  },
  // Inventory Reports
  [PathnameGeneratorInventory(PathnameInventory.STOCK_RECONCILIATION)]: {
    defaultColumns: stockReconciliationReportColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.SLOW_MOVING_INVENTORY)]: {
    defaultColumns: slowMovingInventoryReportColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.WAREHOUSE_STOCK_AGING)]: {
    defaultColumns: warehouseStockAgingReportColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.WAREHOUSE_TRANSFERS)]: {
    defaultColumns: warehouseTransfersReportColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.RETURN_TO_VENDOR)]: {
    defaultColumns: returnToVendorReportColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.INVENTORY_AGING)]: {
    defaultColumns: inventoryAgingReportColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.INVENTORY_COST_ANALYSIS)]: {
    defaultColumns: inventoryCostAnalysisReportColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.STOCK_MOVEMENT_TURNOVER)]: {
    defaultColumns: stockMovementTurnoverReportColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.STOCK_ON_HAND)]: {
    defaultColumns: stockOnHandReportColumns,
  },
  [PathnameGeneratorInventory(PathnameInventory.STOCK_RESERVATION)]: {
    defaultColumns: stockReservationReportColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.BILL_OF_MATERIALS)]: {
    defaultColumns: billOfMaterialColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.GATE_REGISTER)]: {
    defaultColumns: gateRegisterColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.JOB_CARDS)]: {
    defaultColumns: jobCardsColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.MASTER_JOB_CARD)]: {
    defaultColumns: masterJobCardColumns,
  },
  // [PathnameGeneratorManufacuring(PathnameManufacturing.WORK_ORDER)]: {
  //   defaultColumns: workOrderColumns,
  // },
  [PathnameGeneratorManufacuring(PathnameManufacturing.BUILD_ORDER)]: {
    defaultColumns: buildOrderColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.UNBUILD_ORDER)]: {
    defaultColumns: unBuildOrderColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.MANAGE_OPERATIONS)]: {
    defaultColumns: workOrderOperationsColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.OPERATION_BLOCKS)]: {
    defaultColumns: operationBlocksColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.EQUIPMENT_FAILURE)]: {
    defaultColumns: equipmentFailureColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.OPERATIONS)]: {
    defaultColumns: operationsColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.WORK_CENTERS)]: {
    defaultColumns: workCenterColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.EQUIPMENTS)]: {
    defaultColumns: equipmentColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.WORK_CENTER_CATEGORIES)]: {
    defaultColumns: workCenterCategoriesColumns,
  },
  [PathnameGeneratorManufacuring(PathnameManufacturing.ROUTING)]: {
    defaultColumns: routingColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.LEAD)]: {
    defaultColumns: leadColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.OPPORTUNITY)]: {
    defaultColumns: opportunityColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.QUOTATION)]: {
    defaultColumns: quotationColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_ORDER)]: {
    defaultColumns: salesOrderColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_ORDER_DETAIL_REPORT)]: {
    defaultColumns: salesOrderDetailReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_ORDER_SUMMARY_REPORT)]: {
    defaultColumns: salesOrderSummaryReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_INVOICE_SUMMARY_REPORT)]: {
    defaultColumns: salesInvoiceSummaryReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_INVOICE_DETAIL_REPORT)]: {
    defaultColumns: salesInvoiceDetailReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_BY_SALESPERSON_PERFORMANCE)]: {
    defaultColumns: salesBySalespersonPerformanceReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.PENDING_QUOTES_APPROVALS)]: {
    defaultColumns: pendingQuotesApprovalsReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_RETURN_CREDIT_NOTE_REPORT)]: {
    defaultColumns: salesReturnCreditNoteReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.REGIONAL_BRANCH_SALES_PERFORMANCE)]: {
    defaultColumns: regionalBranchSalesPerformanceReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_DISCOUNT_PROMOTION_ANALYSIS)]: {
    defaultColumns: salesDiscountPromotionAnalysisReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_CHANNEL_ANALYSIS)]: {
    defaultColumns: salesChannelAnalysisReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.ORDER_FULFILLMENT_DELIVERY_REPORT)]: {
    defaultColumns: orderFulfillmentDeliveryReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_COMMISSION_INCENTIVE_REPORT)]: {
    defaultColumns: salesCommissionIncentiveReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.CUSTOMER_CHURN_RETENTION_REPORT)]: {
    defaultColumns: customerChurnRetentionReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SALES_BY_PRODUCT_SERVICE_REPORT)]: {
    defaultColumns: salesByProductReportColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.DELIVERTY_ORDER)]: {
    defaultColumns: deliveryOrderColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.CUSTOMER_RETURNS)]: {
    defaultColumns: customerReturnsColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.SHIPMENT_RULES)]: {
    defaultColumns: shippingRuleColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.PROMOTIONS)]: {
    defaultColumns: promotionColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.CUSTOMER_SEGMENTS)]: {
    defaultColumns: customerSegmentColumns,
  },
  [PathnameGeneratorCrm(PathnameCrm.TERMS_AND_CONDITIONS)]: {
    defaultColumns: crmTermsAndConditionsColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.TERMS_AND_CONDITIONS)]: {
    defaultColumns: purchaseTermsAndConditionsColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.REQUESTS)]: {
    defaultColumns: purchaseRequestColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_AGREEMENT)]: {
    defaultColumns: purchaseAgreementColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.RFQ)]: {
    defaultColumns: purchaseRfqColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_ORDER)]: {
    defaultColumns: purchaseOrderColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.VENDOR_RETURNS)]: {
    defaultColumns: purchaseVraColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.DELIVERY_ORDER)]: {
    defaultColumns: purchaseDeliveryOrderColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.LANDED_COST)]: {
    defaultColumns: purchaseLandedCostColumns,
  },
  // Procurement Reports Column Mappings
  [PathnameGeneratorPurchase(PathnamePurchase.APPROVED_VS_PENDING_PO)]: {
    defaultColumns: approvedVsPendingPoReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.MATERIAL_REQUIREMENT_EXCEPTION)]: {
    defaultColumns: materialRequirementExceptionReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.SUPPLIER_CONTRACT_COMPLIANCE)]: {
    defaultColumns: supplierContractComplianceReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.SUPPLIER_RANKING_SCORECARD)]: {
    defaultColumns: supplierRankingScorecardReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_RETURN_REPORT)]: {
    defaultColumns: purchaseReturnReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_ORDER_CANCELLATION)]: {
    defaultColumns: purchaseOrderCancellationReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_ORDER_SUMMARY_REPORT)]: {
    defaultColumns: purchaseOrderSummaryReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_ORDER_DETAIL_REPORT)]: {
    defaultColumns: purchaseOrderDetailReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_TREND_REPORT)]: {
    defaultColumns: purchaseTrendReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.RECEIVED_VS_ORDERED_REPORT)]: {
    defaultColumns: receivedVsOrderedReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.SUPPLIER_AGING_PAYABLE_REPORT)]: {
    defaultColumns: supplierAgingPayableReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_PRICE_VARIANCE_REPORT)]: {
    defaultColumns: purchasePriceVarianceReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.OPEN_PURCHASE_ORDER_REPORT)]: {
    defaultColumns: openPurchaseOrderReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_INVOICE_SUMMARY_REPORT)]: {
    defaultColumns: purchaseInvoiceSummaryReportColumns,
  },
  [PathnameGeneratorPurchase(PathnamePurchase.PURCHASE_INVOICE_DETAIL_REPORT)]: {
    defaultColumns: purchaseInvoiceDetailReportColumns,
  },
  [PathnameGeneratorUsers(PathnameUsers.USER)]: {
    defaultColumns: userColumns,
  },
  [PathnameGeneratorUsers(PathnameUsers.LANGUAGE)]: {
    defaultColumns: languageColumns,
  },

  // Rental Module
  [PathnameGeneratorRental(PathnameRental.TERMS_AND_CONDITIONS)]: {
    defaultColumns: rentalTermsAndConditionsColumns,
  },
  [PathnameGeneratorRental(PathnameRental.CONFIGURATIONS)]: {
    defaultColumns: rentalConfigurationColumns,
  },
  [PathnameGeneratorRental(PathnameRental.BILLING_CYCLE)]: {
    defaultColumns: rentalBillingCycleColumns,
  },
  [PathnameGeneratorRental(PathnameRental.OPPORTUNITY)]: {
    defaultColumns: rentalOpportunityColumns,
  },
  [PathnameGeneratorRental(PathnameRental.LEADS)]: {
    defaultColumns: rentalLeadColumns,
  },
  [PathnameGeneratorRental(PathnameRental.QUOTATION)]: {
    defaultColumns: rentalQuotationColumns,
  },
  [PathnameGeneratorRental(PathnameRental.REVISED_QUOTATION)]: {
    defaultColumns: rentalQuotationColumns,
  },
  [PathnameGeneratorRental(PathnameRental.AGREEMENTS)]: {
    defaultColumns: rentalAgreementsColumns,
  },
  [PathnameGeneratorRental(PathnameRental.CROSS_HIRE_REQUESTS)]: {
    defaultColumns: rentalCrossHireRequestColumns,
  },
  [PathnameGeneratorRental(PathnameRental.CROSS_HIRE_RFQ)]: {
    defaultColumns: rentalCrossHireRfqColumns,
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_ORDERS)]: {
    defaultColumns: rentalOrderColumns,
  },
  [PathnameGeneratorRental(PathnameRental.PURCHASE_REQUEST_FOR_QUOTE)]: {
    defaultColumns: purchaseRfqColumns,
  },
  [PathnameGeneratorRental(PathnameRental.PURCHASE_ORDERS)]: {
    defaultColumns: purchaseOrderColumns,
  },
  [PathnameGeneratorUsers(PathnameUsers.USER)]: {
    defaultColumns: userColumns,
  },
  [PathnameGeneratorRental(PathnameRental.CROSS_HIRE_ORDERS)]: {
    defaultColumns: rentalCrossHireOrderColumns,
  },
  [PathnameGeneratorRental(PathnameRental.ITEM)]: {
    defaultColumns: inventoryItemColumns,
  },
  [PathnameGeneratorRental(PathnameRental.ITEM_CATEGORY)]: {
    defaultColumns: itemCategoryColumns,
  },
  [PathnameGeneratorUsers(PathnameUsers.ROLE)]: {
    defaultColumns: rolesColumns,
  },

  // Rental Reports
  [PathnameGeneratorRental(PathnameRental.RENTAL_REVENUE_REPORT)]: {
    defaultColumns: rentalRevenueReportColumns,
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_AGREEMENT_REPORT)]: {
    defaultColumns: rentalAgreementReportColumns,
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_AGREEMENT_DETAIL_REPORT)]: {
    defaultColumns: rentalAgreementDetailReportColumns,
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_ASSET_RETURN_REPORT)]: {
    defaultColumns: rentalAssetReturnReportColumns,
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_CANCELLATIONS_AMENDMENTS_REPORT)]: {
    defaultColumns: rentalCancellationsAmendmentsReportColumns,
  },
  [PathnameGeneratorRental(PathnameRental.RENTAL_PAYMENT_AGING_REPORT)]: {
    defaultColumns: rentalPaymentAgingReportColumns,
  },
  [PathnameGeneratorRental(PathnameRental.ACTIVE_RENTALS_REPORT)]: {
    defaultColumns: activeRentalsReportColumns,
  },
  [PathnameGeneratorRental(PathnameRental.UPCOMING_EXPIRY_REPORT)]: {
    defaultColumns: upcomingExpiryReportColumns,
  },
  [PathnameGeneratorRental(PathnameRental.ASSET_AVAILABILITY_REPORT)]: {
    defaultColumns: assetAvailabilityReportColumns,
  },
  [PathnameGeneratorRental(PathnameRental.ASSET_UTILIZATION_REPORT)]: {
    defaultColumns: assetUtilizationReportColumns,
  },
  [PathnameGeneratorRental(PathnameRental.ASSET_CATEGORY_PERFORMANCE_REPORT)]: {
    defaultColumns: assetCategoryPerformanceReportColumns,
  },
  [PathnameGeneratorRental(PathnameRental.CUSTOMER_RENTAL_REPORT)]: {
    defaultColumns: customerRentalReportColumns,
  },
  ...(Object.values(Pathname).reduce((acc, path) => {
    acc[`${path}${TEMPLATE_EDITOR_PATHS.TEMPLATES_LIST('email')}`] = {
      defaultColumns: emailColumns,
    };
    acc[`${path}${TEMPLATE_EDITOR_PATHS.TEMPLATES_LIST('pdf')}`] = {
      defaultColumns: emailColumns,
    };
    return acc;
  }, {})),
  // [PathnameGeneratorUsers(PathnameUsers.EMAILS)]: {
  //   defaultColumns: emailColumns,
  // },

  // HRMS Module
  [PathnameGeneratorHrms(PathnameHrms.LOAN_CONFIGURATION)]: {
    defaultColumns: hrmsLoanConfigurationColumns,
  },
  [PathnameGeneratorHrms(PathnameHrms.DOCUMENT_MASTER)]: {
    defaultColumns: hrmsDocumentMasterColumns,
  },
  [PathnameGeneratorHrms(PathnameHrms.COMPANY_CALENDAR)]: {
    defaultColumns: hrmsCompanyCalendarColumns,
  },
  [PathnameGeneratorHrms(PathnameHrms.LEAVE_POLICY_MASTER)]: {
    defaultColumns: hrmsLeavePolicyMasterColumns,
  },
  [PathnameGeneratorHrms(PathnameHrms.SALARY_STRUCTURE_MASTER)]: {
    defaultColumns: hrmsSalaryStructureMasterColumns,
  },
  [PathnameGeneratorHrms(PathnameHrms.EMPLOYEE_MANAGEMENT)]: {
    defaultColumns: hrmsEmployeeManagementColumns,
  },
  // [PathnameGeneratorHrms(PathnameHrms.EMPLOYEE_CONTRACT)]: {
  //   defaultColumns: hrmsEmployeeContractColumns,
  // },
  // [PathnameGeneratorHrms(PathnameHrms.EMPLOYEE_LEAVE)]: {
  //   defaultColumns: hrmsEmployeeLeaveColumns,
  // },
  // [PathnameGeneratorHrms(PathnameHrms.EMPLOYEE_LEAVE_REQUEST)]: {
  //   defaultColumns: hrmsEmployeeLeaveRequestColumns,
  // },
};
